import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "conversation-list bg-gray-800 rounded-lg overflow-hidden h-full flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "p-6 text-center text-gray-400 flex-grow flex items-center justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "p-6 text-center text-gray-400 flex-grow flex flex-col items-center justify-center"
}
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col flex-grow"
}
const _hoisted_5 = { class: "divide-y divide-gray-700 overflow-y-auto flex-grow" }
const _hoisted_6 = {
  key: 0,
  class: "p-3 bg-gray-700 border-t border-gray-600"
}
const _hoisted_7 = { class: "fixed inset-0 flex items-center justify-center z-50" }
const _hoisted_8 = { class: "bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 transform transition-all duration-300 border-l-4 border-l-yellow-500" }
const _hoisted_9 = { class: "flex items-start" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = { class: "flex justify-between items-start" }
const _hoisted_12 = { class: "text-lg font-medium mb-2 text-yellow-400" }
const _hoisted_13 = { class: "text-base text-gray-300" }
const _hoisted_14 = { class: "mt-4 flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_conversation_item = _resolveComponent("conversation-item")!
  const _component_pagination_component = _resolveComponent("pagination-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "p-4 bg-gray-700 border-b border-gray-600" }, [
      _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Razgovori")
    ], -1)),
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "flex items-center" }, [
            _createElementVNode("svg", {
              class: "animate-spin h-5 w-5 mr-2",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              })
            ]),
            _createTextVNode(" Učitavanje... ")
          ], -1)
        ])))
      : (_ctx.conversations.length === 0 && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[5] || (_cache[5] = [
            _createElementVNode("p", null, "Nemate aktivnih razgovora", -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conversation) => {
                return (_openBlock(), _createBlock(_component_conversation_item, {
                  key: `${conversation.otherUser.id}-${conversation.product.id}`,
                  conversation: conversation,
                  isActive: _ctx.isActiveConversation(conversation),
                  onClick: ($event: any) => (_ctx.selectConversation(conversation)),
                  onDelete: ($event: any) => (_ctx.showDeleteConfirmation(conversation))
                }, null, 8, ["conversation", "isActive", "onClick", "onDelete"]))
              }), 128))
            ]),
            (_ctx.meta && _ctx.meta.totalPages > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_pagination_component, {
                    meta: _ctx.meta,
                    "current-page": _ctx.meta.page,
                    "max-visible-pages": 5,
                    "scroll-to-top": false,
                    onPageChange: _ctx.handlePageChange
                  }, null, 8, ["meta", "current-page", "onPageChange"])
                ]))
              : _createCommentVNode("", true)
          ])),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeConfirmToast && _ctx.closeConfirmToast(...args)))
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0 mr-4" }, [
            _createElementVNode("svg", {
              class: "h-8 w-8 text-yellow-400",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.confirmToast.title), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeConfirmToast && _ctx.closeConfirmToast(...args))),
                class: "ml-4 text-gray-400 hover:text-gray-300 transition-colors"
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5",
                  viewBox: "0 0 20 20",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                    "clip-rule": "evenodd"
                  })
                ], -1)
              ]))
            ]),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.confirmToast.message), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeConfirmToast && _ctx.closeConfirmToast(...args))),
                class: "px-4 py-2 rounded-md text-sm font-medium bg-gray-600 hover:bg-gray-700 text-white transition-colors"
              }, " Odustani "),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleConfirmDelete && _ctx.handleConfirmDelete(...args))),
                class: "px-4 py-2 rounded-md text-sm font-medium bg-red-600 hover:bg-red-700 text-white transition-colors"
              }, " Obriši ")
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.confirmToast.show]
    ])
  ]))
}